// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"ProductCheckoutCardActions_useFade-fadeIn__t2ySV","useFade-fadeOut":"ProductCheckoutCardActions_useFade-fadeOut__RQAnp"};